module.exports = __webpack_public_path__ + "static/img/1993.74f75951.jpg";